import { DownloadOutlined } from '@ant-design/icons';
import { Alert, Button } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from "react";
import { useFetcher, useLoaderData } from 'react-router-dom';
// import { Box } from '../../../components/design/box.js';
import { DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
import { ItemClientStatuses } from '../../../library/constants/ItemClientStatuses.js';
import { OrderShippingStatuses } from '../../../library/constants/shipping-statuses.js';

import { Box } from '../../../components/design';
import { getFilePath } from '../../../library/constants/urls.js';
import { formatDate } from '../../../library/utils/intl.js';
import styles from "./dispatchdateconfirm.module.scss";
import { ShipmentExpectedDispatchDate } from './inProduction.jsx';

export const ShipmentConfirmDispatchDate = ({ projectId, item, deliveryType = null }) => {
    const fetcher = useFetcher()
    const [selectedQuantity, setSelectedQuantity] = useState(null)
    const { errors = {} } = fetcher.data || {}

    const quantityValidationMessage = useMemo(() => {
        if (!selectedQuantity) {
            return
        }
        if (selectedQuantity < (item.quantity * 0.9)) {
            return 'Dispatch quantity is less than 10% of confirmed quantity'
        }
        if (selectedQuantity > (item.quantity * 1.1)) {
            return 'Dispatch quantity cannot be greater than 10% of confirmed quantity'
        }
    }, [item.quantity, selectedQuantity])

    const address = (deliveryType === 3) ?
        <Button href={getFilePath(item.bulk_address_file.url, projectId)} icon={<DownloadOutlined />}>Download</Button> :
        <>{item.street_number},{item.street},{item.city}</>

    return (
        <fetcher.Form method="post" encType={deliveryType === 3 ? 'multipart/form-data' : 'application/x-www-form-urlencoded'}>
            <input type="hidden" name="shipment_id" value={item.id} />
            <div className={deliveryType === 3 ? styles.deliveryRowWithComment : styles.deliveryRow}>
                <div className="quantity">{item.quantity}</div>
                <div className="address">{address}</div>
                <div className="field-expected_date">
                    {formatDate(item.dispatch_date)}
                </div>
                <div className="field-quantity">
                    <InputWrapper type='Number' min={0} name="ship_quantity" defaultValue={item.ship_quantity} onChange={(e) => {
                        setSelectedQuantity(e.target.value)
                    }} errors={errors} />
                    <span className="error" style={{ color: "red" }}>{quantityValidationMessage}</span>
                </div>
                {deliveryType === 3 ? (
                    <>
                        <div className="field">
                            <FieldWrapper name="delivery_file" errors={errors} >
                                <input type="file" name="delivery_file" />
                            </FieldWrapper>
                        </div>
                        <div className="field">
                            <InputWrapper name="delivery_comment" defaultValue={item.delivery_comment} errors={errors} textarea />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="field-trackingurl">
                            <InputWrapper name="tracking_url" defaultValue={item.tracking_url} errors={errors} />
                        </div>
                    </>
                )}
                <div className="field-expected_date">
                    <FieldWrapper name="" errors={errors} >
                        <DatePicker name="expected_date" useHidden value={item.expected_date} />
                    </FieldWrapper>
                </div>
                <Button
                    type="primary"
                    htmlType='submit'
                    name="action"
                    value={deliveryType === 3 ? 'updateDeliveryInformationBulk' : 'updateDeliveryInformation'}
                    loading={fetcher.state !== 'idle'}
                    disabled={!!quantityValidationMessage}
                >Submit</Button>
            </div>
        </fetcher.Form>
    )
}
ShipmentConfirmDispatchDate.propTypes = {
    projectId: PropTypes.number.isRequired,
    itemId: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    deliveryType: PropTypes.oneOf([1, 2, 3]),
}


const ExpecetedDispatchDate = () => {
    const { productionDetails } = useLoaderData()
    const missingExpectedDateShipments = productionDetails.item_delivery_address.filter(({ status }) => status === OrderShippingStatuses.NEW)
    const dispachableShipments = productionDetails.item_delivery_address.filter(({ status }) => status === OrderShippingStatuses.DISPATCH_DATE_ADDED)

    return <div className={styles.container}>
        <h3>Task For You</h3>
        {![ItemClientStatuses.IN_TRANSIT, ItemClientStatuses.DELIVERED].includes(productionDetails.client_status) ? (
            <Alert description="You have shared the expected dispatch date" type="info" showIcon />
        ) : (
            <Alert description="You have shared the expected dispatch date. Leoprinting is already notified." type="info" showIcon />
        )}
        <Box header={
            <div className={productionDetails.delivery_type === 3 ? styles.deliveryRowHeadWithComment : styles.deliveryRowHead}>
                <div>Quantity</div>
                <div>Delivery Address</div>
                <div>Expected Dispatch Date</div>
                <div>Ship Quantity</div>
                {productionDetails.delivery_type === 3 ? (
                    <>
                        <div>Delivery File</div>
                        <div>Comment</div>
                    </>
                ) : (
                    <>
                        <div>Tracking URL</div>
                    </>
                )}
                <div>Expected Delivery Date</div>
                <div></div>
            </div>
        }>
            {dispachableShipments.length > 0 && dispachableShipments.map((shipment) => <ShipmentConfirmDispatchDate key={shipment.id} projectId={productionDetails.project_id} itemId={productionDetails.id} deliveryType={productionDetails.delivery_type} item={shipment} />)}
        </Box>
        {missingExpectedDateShipments.length > 0 && (
            <>
                <Alert description="Please provide an expected shipment details for following items" type="error" showIcon />
                <ShipmentExpectedDispatchDate projectId={productionDetails.project_id} itemId={productionDetails.id} deliveryType={productionDetails.delivery_type} shipments={missingExpectedDateShipments} buttonText='Save Dates' />
            </>
        )}
    </div>
}


export default ExpecetedDispatchDate




// import { CheckOutlined } from '@ant-design/icons';
// import { Button, Tooltip } from 'antd';
// import PropTypes from 'prop-types';
// import React from "react";
// import { useFetcher, useLoaderData } from 'react-router-dom';
// import { Box } from '../../../components/design/box';
// import { DatePicker, FieldWrapper, InputWrapper } from "../../../components/inputs";
// import styles from "./expected-dispatch-date.module.scss";
// import { formatDate } from '../../../library/utils';

// const DeliveryTrackingRow = ({ item }) => {
//     const fetcher = useFetcher()
//     const { errors = {} } = fetcher.data || {}
//     return (
//         <fetcher.Form method="post">
//             <input type="hidden" name="shipment_id" value={item.id} />
//             <div className={styles.deliveryRow}>
//                 <div className="quantity">{item.quantity}</div>
//                 <div className="address">{item.street_number},{item.street},{item.city}</div>
//                 <div className="field-quantity">
//                     <InputWrapper type='Number' min={0} name="ship_quantity" defaultValue={item.ship_quantity} errors={errors} />
//                 </div>
//                 <div className="field-trackingurl">
//                     <InputWrapper name="tracking_url" defaultValue={item.tracking_url} errors={errors} />
//                 </div>
//                 <div className="field-expecteddate">
//                     <FieldWrapper name="expected_date" errors={errors} >
//                         <DatePicker name="expected_date" value={item.expected_date} useHidden />
//                     </FieldWrapper>
//                 </div>
//                 <div>{formatDate(item.dispatch_date)}</div>
//                 <Tooltip title={"Click on this box to send the shipped quantity, track and trace (if available), and dispatch date to Leoprinting"}>
//                     <Button
//                         type="primary"
//                         htmlType='submit'
//                         name="action"
//                         value="updateDeliveryInformation"
//                         icon={<CheckOutlined />}
//                         loading={fetcher.state !== 'idle'}
//                     />
//                 </Tooltip>
//             </div>
//         </fetcher.Form>
//     )
// }
// DeliveryTrackingRow.propTypes = {
//     item: PropTypes.object.isRequired
// }

// const ExpecetedDispatchDate = () => {
//     const { deliveryDetails } = useLoaderData()
//     return (
//         <div className={styles.container}>
//             <h3>Task For You</h3>
//             <Box header={
//                 <div className={styles.deliveryRowHead}>
//                     <div>Quantity</div>
//                     <div>Delivery Address</div>
//                     <div>Ship Quantity</div>
//                     <div>Tracking URL</div>
//                     <div>Expected Delivery Date</div>
//                     <div>Expected Dispatch Date</div>
//                     <div></div>
//                 </div>
//             }>
//                 {deliveryDetails && deliveryDetails.map((shipment) => <DeliveryTrackingRow key={shipment.id} item={shipment} />)}
//             </Box>
//         </div>
//     )
// }


// export default ExpecetedDispatchDate;



